import { observer } from 'mobx-react-lite'
import { styled } from '../../../../lib/stitches'
import { Box, Column, Row } from '../../../core/Components'
import { FieldLabel } from '../../../core/FieldLabel'
import Text from '../../../core/Text/Text'
import { gray11, gray3 } from '../../../platform/color'
import { MintLoader } from './Loader'
import MintSoundTerms from './MintSoundTerms'
import MintSoundUploadPage, { UploadSoundModalForm } from './MintSoundUploadPage'
import { MintSuccess } from './MintSuccess'
import useMintSoundModalContent from './useMintSoundModalContent'

export const SectionHeader = styled(FieldLabel, {
  fontSize: '16px',
  paddingBottom: '16px',
  variants: {
    bold: {
      true: {
        fontWeight: '700px'
      }
    }
  }
})

export const ColumnLabel = styled(Text, {
  margin: '0',
  color: gray11,
  fontSize: '14px',
  padding: '12px 12px'
})

export const HeaderContainer = styled(Column, {
  // padding: '24px 0px 0px 0px',
  borderBottom: `1px solid ${gray3}`
})

export const FooterContainer = styled(Row, {
  padding: '24px 0px 0px 0px',
  borderTop: `1px solid ${gray3}`,
  variants: {
    stretch: {
      true: {
        justifyContent: 'stretch'
      }
    },
    end: {
      true: {
        justifyContent: 'end'
      }
    }
  }
})

export type SoundValidation = {
  accepted: boolean
  name: string
  size: number
  form: UploadSoundModalForm
  file?: File
  errors: { [field: string]: string }
} | null

export type InstrumentType = string

const MintSoundModalContent = observer(() => {
  const {
    onClickNavigateToSound,
    soundPath,
    getInputProps,
    getRootProps,
    soundValidations,
    handleSubmit,
    page,
    handleMint,
    onCancel,
    setSoundValidations,
    isValid
  } = useMintSoundModalContent()

  return (
    <Box css={{ padding: '32px' }}>
      {page === 'upload' && (
        <MintSoundUploadPage
          soundValidations={soundValidations}
          onCancel={onCancel}
          getInputProps={getInputProps}
          getRootProps={getRootProps}
          handleSubmit={handleSubmit}
          setSoundValidations={setSoundValidations}
          isValid={isValid}
        />
      )}
      {page === 'terms' && <MintSoundTerms handleMint={handleMint} onCancel={onCancel} />}
      {page === 'minting' && <MintLoader />}
      {page === 'minted' && (
        <MintSuccess onClickNavigateToSound={onClickNavigateToSound} soundPath={soundPath} />
      )}
    </Box>
  )
})

export default MintSoundModalContent
